/* eslint-disable no-trailing-spaces */
import React, { useContext, useState, useEffect } from "react";

import OwlCarousel from 'react-owl-carousel3';

import { getFromApi } from '../../lib/js/api'

function IndexComponent(props) {

  const [domain, setDomain] = useState(null)
  const [products, setProducts] = useState([])
  const [menus, setMenus] = useState([])

  useEffect(() => {

    let business = window.business
    let hostname = window.location.host || ""
    let menus = window.menus || [{}]
    menus = menus.filter((m) => m.enabled == true)

    menus.sort((a, b) => a.Location.city.localeCompare(b.Location.city))

    setMenus(menus)

    if (business) {

      // get the products for the business if assets are empty
      setDomain(business.uuid.toLowerCase())

      if (business.Assets.length == 0) {
        let path = `/api/v1/business/${business.id}/products`

        getFromApi(
          path, {}, (data) => {
            //console.log("got products", data.result)
            let products = data.result.filter((p) => p.photo != "" && p.photo != business.photo)

            if (products.length > 5) {
              setProducts(products.slice(0, 5))
            } else {
              setProducts(products)
            }
          }, (error) => {
            console.log("Error", error)
          }
        )

      }


      let css = document.createElement('style');

      css.innerHTML = `
      body {
        background-color: #000000;
        color: #ffffff;
      }
  .home-container {
        background-color: #000000;
        color: #ffffff;
      }
       .home-container .social-button i {
      color: #ffffff;
    }
    `;


      if (business.style && business.style != "") {
        css.innerHTML = business.style
      } else if (business.colour && business.colour != "") {
        let style = {
          backgroundColor: _prefixedColour(business.colour),
          color: invertColor(business.colour, true)
        }
        css.innerHTML = `
        body {
          background-color: ${style.backgroundColor};
          color: ${style.color};
        }
        .home-container {
      background-color: ${style.backgroundColor};
      color: ${style.color};
    }
    .home-container .social-button i {
      color: ${style.color};
    }
  `;
      }

      //console.log("style", css.innerHTML)

      document.head.appendChild(css);

    }

  }, [])

  const _logoDiv = (hostname) => {

    return (
      <a href="https://ally.zono.cc" target="blank">
        <div className="col centered"><img src="/images/zono-smile.png" width={100} /></div>
      </a>
    )

  }

  //console.log("business", business)
  //console.log("menus", menus)

  const assetsRow = () => {

    const options = {
      responsive: {
        0: {
          items: 1,
        },
        600: {
          items: 1,
        },
        1000: {
          items: 2,
        },
        1200: {
          items: 3,
        },
      },
      items: business.Assets.length,
      lazyLoad: true,
      pagination: "false",
      loop: true,
      center: true,
      dots: true,
      loop: true,
      //margin: 10,
      autoplay: true,
      autoplayTimeout: 3000,
      autoplayHoverPause: true,
      nav: false,
      navText: ["<i class='icofont-thin-left'></i>", "<i class='icofont-thin-right'></i>"]
    }

    if (business.Assets && business.Assets.length > 1) {
      // return a carousel with the assets
      return (
        <div className="row ">
          <div className="col-12 centered">
            <OwlCarousel nav loop {...options} className="owl-theme owl-carousel-five offers-interested-carousel">
              {business.Assets.map((a, index) => {
                return (
                  <div className="item" key={`carouselImg_${index}`}>
                    <img src={a.url} style={{
                      maxHeight: 200,
                      minHeight: 200,
                      maxWidth: 500,
                      //objectFit: 'cover'
                    }} />
                  </div>
                )
              })

              }

            </OwlCarousel>
          </div>
        </div>
      )
    } else if (products.length > 0) {
      // return the asset image
      return (
        <div className="row ">
          <div className="col-12 centered">
            <OwlCarousel nav loop {...options} className="owl-theme owl-carousel-five offers-interested-carousel">
              {products.map((a, index) => {
                return (
                  <div className="item" key={`carouselImg_${index}`}>
                    <img src={a.photo} style={{
                      maxHeight: 200,
                      minHeight: 200,
                      maxWidth: 500,
                      //objectFit: 'cover'
                    }} />
                  </div>
                )
              })

              }

            </OwlCarousel>
          </div>
        </div>
      )
    } else if (business.banner && business.banner != "") {
      // return the business banner
      return (
        <div className="row logo-row">
          <div className="col centered"><img src={business.banner} style={{
            maxHeight: 200,
            minHeight: 100,
            maxWidth: 600,
            objectFit: 'cover'
          }} /></div>
        </div>
      )
    }

    return <></>

  }

  const _prefixedColour = (colour) => {
    if (colour.indexOf('#') !== 0) {
      return '#' + colour
    }
    return colour
  }

  function padZero(str, len) {
    len = len || 2;
    var zeros = new Array(len).join('0');
    return (zeros + str).slice(-len);
  }

  function invertColor(hex, bw) {
    if (hex.indexOf('#') === 0) {
      hex = hex.slice(1);
    }
    // convert 3-digit hex to 6-digits.
    if (hex.length === 3) {
      hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
    }
    if (hex.length !== 6) {
      throw new Error('Invalid HEX color.');
    }
    var r = parseInt(hex.slice(0, 2), 16),
      g = parseInt(hex.slice(2, 4), 16),
      b = parseInt(hex.slice(4, 6), 16);
    if (bw) {
      // https://stackoverflow.com/a/3943023/112731
      return (r * 0.299 + g * 0.587 + b * 0.114) > 186
        ? '#000000'
        : '#FFFFFF';
    }
    // invert color components
    r = (255 - r).toString(16);
    g = (255 - g).toString(16);
    b = (255 - b).toString(16);
    // pad each with zeros and return
    return "#" + padZero(r) + padZero(g) + padZero(b);
  }

  // we have to use this url for menus so the address book works for all
  // businesses on zono.cc
  // served by src/business/business.go:SetupPublicRoutes()
  const slugUrl = (uuid) => {
    console.log("slug url", window.location.href)

    if (window.location.href.includes("localhost")) {
      return `http://localhost:3008/m/${domain}/${uuid}`
    }
    return `https://zono.cc/m/${domain}/${uuid}`
  }
  /*
    const domainSlugUrl = (uuid) => {
      return `https://${domain}.zono.cc/${uuid}`
    } */

  const isEmpty = (str) => {
    return str == null || str == ""
  }

  const twitterButton = (business) => {
    if (isEmpty(business.twitter)) return <></>

    if (business.twitter.startsWith("https")) {
      return (
        <a href={business.twitter}>
          <span className="social-button" >
            <i className="zmdi zmdi-twitter" style={{ fontSize: 30 }}></i>
          </span>
        </a>
      )
    }
    return (
      <a href={"https://twitter.com/" + business.twitter}>
        <span className="social-button" >
          <i className="zmdi zmdi-twitter" style={{ fontSize: 30 }}></i>
        </span>
      </a>
    )
  }

  const facebookButton = (business) => {
    if (isEmpty(business.facebook)) return <></>
    if (business.facebook.startsWith("https")) {
      return (
        <a href={business.facebook}>
          <span className="social-button" >
            <i className="zmdi zmdi-facebook" style={{ fontSize: 30 }}></i>
          </span>
        </a>
      )
    }
    return (
      <a href={"https://facebook.com/" + business.facebook}>
        <span className="social-button" >
          <i className="zmdi zmdi-facebook" style={{ fontSize: 30 }}></i>
        </span>
      </a>
    )
  }

  const whatsappButton = (business) => {
    if (isEmpty(business.whatsapp)) return <></>

    let phone = business.whatsapp
    if (phone.startsWith('+')) phone = phone.slice(1)

    return (
      <a href={"https://wa.me/" + phone}>
        <span className="social-button" >
          <i className="zmdi zmdi-whatsapp" style={{ fontSize: 30 }}></i>
        </span>
      </a>
    )
  }

  const instagramButton = (business) => {
    if (isEmpty(business.instagram)) return <></>
    if (business.instagram.startsWith("https")) {
      return (
        <a href={business.instagram}>
          <span className="social-button" >
            <i className="zmdi zmdi-instagram" style={{ fontSize: 30 }}></i>
          </span>
        </a>
      )
    }
    return (
      <a href={"https://instagram.com/" + business.instagram}>
        <span className="social-button" >
          <i className="zmdi zmdi-instagram" style={{ fontSize: 30 }}></i>
        </span>
      </a>
    )
  }

  const youtubeButton = (business) => {
    if (isEmpty(business.youtube)) return <></>
    if (business.youtube.startsWith("https")) {
      return (
        <a href={business.youtube}>
          <span className="social-button" >
            <i className="zmdi zmdi-youtube" style={{ fontSize: 30 }}></i>
          </span>
        </a>

      )
    }
    return (
      <a href={"https://youtube.com/" + business.youtube}>
        <span className="social-button" >
          <i className="zmdi zmdi-youtube" style={{ fontSize: 30 }}></i>
        </span>
      </a>
    )

  }

  const contentForLink = (link) => {
    if (link.photo != "") {
      return <img src={link.photo} style={{ maxHeight: 80, marginBottom: '0.5rem' }} />
    }

    return <h2><div className="button centered v-centered br-15 styled-button">{link.title}</div></h2>
  }

  //console.log("business", business)

  const linkOrImageButton = (menu, link, name) => {
    if (menu.button == "") {
      return (

        <div className="menu-link-row " key={`menu_${menu.id}`} >
          <div></div>
          <a href={link}>
            <h2><div className="button centered v-centered br-15 styled-button">{name}</div></h2>
          </a>
          <div></div>
        </div>

      )
    }
    return (
      <div className="menu-link-row " key={`menu_${menu.id}`} >
        <div></div>
        <a href={link}>
          <img src={menu.button} style={{ maxHeight: 80, marginBottom: '0.5rem' }} />
        </a>
        <div></div>
      </div>
    )
  }

  const communityLinks = () => {

    if (window.communityCount == 0 &&
      window.eventCount == 0 &&
      window.offersCount == 0
    ) return <></>

    return <div className="centered my-2">

      <div className="row"  >
        <div className="col v-centered"
          onClick={() => window.location.href = `https://app.zono.cc/page/${business.uuid}/offers`}
        >
          <span className="material-symbols-outlined md-36">
            grade
          </span>

          <span>Planes</span>
        </div>
        <div className="col v-centered"
          onClick={() => window.location.href = `https://app.zono.cc/page/${business.uuid}/community`}
        >
          <span className="material-symbols-outlined md-36">
            groups
          </span>
          <span>Communidad</span>
        </div>
      {/*   <div className="col v-centered"
          onClick={() => window.location.href = `https://app.zono.cc/page/${business.uuid}/events`}
        >
          <span className="material-symbols-outlined md-36">
            event_available
          </span>
          <span>Eventos</span>
        </div> */}
      </div>

    </div>
  }

  const menusAndLinks = () => {
    if (business && business.flags && business.flags.includes("linksFirst")) {
      return (
        <>

          {business.Links && business.Links.map((m) => {

            return (

              <div className="menu-link-row " key={`menu_${m.id}`} >
                <div></div>
                <a href={m.link}>

                  {contentForLink(m)}

                </a>
                <div></div>
              </div>

            )
          })}
          {menus.map((m) => {

            let name = m.linkTitle

            if (name == "") {
              let parts = [m.name, m.Location.city]

              // if there is only 1 location no need to show the city
              if (m.name == m.Location.city || menus.length == 1) {
                parts.pop()
              }
              name = parts.filter((p) => p && p != '').join(' - ')

              //console.log("parts", name, parts, m.name, m.Location.city)
            }

            if (m.Location.uuid != "") {
              return linkOrImageButton(m, slugUrl(m.Location.uuid), name)

            }

            // location uuid is blank so go directly to the menu using business, location and menu IDs
            return (

              <div className="menu-link-row " key={`menu_${m.id}`} >
                <div></div>
                <a href={`https://zono.cc/?bid=${m.business_id}&lid=${m.location_id}&mid=${m.id}`}>

                  <h2><div className="button centered v-centered br-15 styled-button">{name}</div></h2>

                </a>
                <div></div>
              </div>

            )

          })}

        </>
      )
    }
    return (
      <>

        {menus.map((m) => {

          let name = m.linkTitle

          if (name == "") {
            let parts = [m.name, m.Location.city]

            // if there is only 1 location no need to show the city
            if (m.name == m.Location.city || menus.length == 1) {
              parts.pop()
            }
            name = parts.filter((p) => p && p != '').join(' - ')

            //console.log("parts", name, parts, m.name, m.Location.city)
          }

          if (m.Location.uuid != "") {
            return linkOrImageButton(m, slugUrl(m.Location.uuid), name)

          }

          // location uuid is blank so go directly to the menu using business, location and menu IDs
          return (

            <div className="menu-link-row " key={`menu_${m.id}`} >
              <div></div>
              <a href={`https://zono.cc/?bid=${m.business_id}&lid=${m.location_id}&mid=${m.id}`}>

                <h2><div className="button centered v-centered br-15 styled-button">{name}</div></h2>

              </a>
              <div></div>
            </div>

          )

        })}

        {business.Links && business.Links.map((m) => {

          return (

            <div className="menu-link-row " key={`menu_${m.id}`} >
              <div></div>
              <a href={m.link}>

                {contentForLink(m)}

              </a>
              <div></div>
            </div>

          )
        })}
      </>
    )
  }

  console.log("business", business)

  return (

    <div className="menu-container business-container"  >
      <div className="row logo-row"   >
        <div className="col centered"><img src={business.photo} width={250} /></div>
      </div>

      {assetsRow()}

      <div className="row"  >
        <div className="col centered"><span>{business.description}</span></div>
      </div>

      {menusAndLinks()}


      <div className="centered">
        <div className="social-row  ">
          <div>
            &nbsp;

          </div>
          <div>
            {twitterButton(business)}
            {facebookButton(business)}
            {whatsappButton(business)}
            {instagramButton(business)}
            {youtubeButton(business)}
          </div>
          <div>
            &nbsp;
          </div>

        </div>
      </div>

      <div className="row  powered-row">
        <div className="col centered"><span>Powered By</span></div>
      </div>

      <div className="row logo-row">
        <a href="https://zono.cc" target="blank">
          <div className="col centered"><img src="/images/zono-smile.png" width={100} /></div>
        </a>
      </div>

    </div>
  )

}

IndexComponent.propTypes = {
  //classes: PropTypes.object.isRequired,
  //theme: PropTypes.object.isRequired,
}


export default IndexComponent
